import React, {Component} from "react";
import "../../style/notificationsList.css";

class NotificationsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hiddenItems: []
        }
    }

    onDismiss = (key) => {
        this.setState({
            ...this.state,
            hiddenItems: [
                ...this.state.hiddenItems,
                key
            ]
        });
    };

    mapPositionToClass = (position) => {
        if (position === 'topRight') {
            return "top-right";
        }

        if (position === 'centerLeft') {
            return "center-left";
        }

        return "";
    };

    mapVariantToClass = (variant) => {
        if (variant === "error") {
            return "alert-danger";
        }

        if (variant === "success") {
            return "alert-success";
        }

        return "alert-info";
    };

    render() {
        const { position, notifications, variant } = this.props;
        const positionClassName = this.mapPositionToClass(position);
        const variantMapping = this.mapVariantToClass(variant);
        return (
            <div className={`notifications-list ${positionClassName} fade in`}>
                {notifications
                    .filter((notification) => !this.state.hiddenItems.includes(notification.key))
                    .map((notification) => (
                        <div key={notification.key} className={`alert alert-dismissible ${variantMapping}`}>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="alert"
                                onClick={() => {
                                    if (notification.callback) {
                                        notification.callback(notification);
                                    } else {
                                        this.onDismiss(notification.key);
                                    }

                                }}
                            >
                                ×
                            </button>
                            <p className="mb-0">
                                <small/>
                                {notification.label}
                            </p>
                        </div>
                    ))}
            </div>
        );
    }
}

export default NotificationsList;